import { FirebaseError } from 'firebase/app'
import { confirmPasswordReset, getAuth, verifyPasswordResetCode } from 'firebase/auth'
import { apiClient, handleResponse } from '@/utils/axios-client.ts'
import { z } from 'zod'

const RESET_PASSWORD_ENDPOINT = '/api/v1/user-reset-password'

/**
 * Fonction API pour envoyer l'email de réinitialisation de mot de passe.
 * @param email L'adresse email de l'utilisateur.
 */
export async function sendPasswordReset(email: string): Promise<void> {
  return handleResponse(
    () => apiClient.post(`${RESET_PASSWORD_ENDPOINT}`, { email: email }),
    z.any()
  )
}

export const updatePassword = async ({
  newPassword,
  oobCode
}: {
  newPassword: string
  oobCode: string
}): Promise<void> => {
  return confirmPasswordReset(getAuth(), oobCode, newPassword)
}

export const verifyPasswordCode = async ({
  oobCode
}: {
  oobCode: string
}): Promise<boolean> => {
  try {
    await verifyPasswordResetCode(getAuth(), oobCode)
    return true
  } catch (e) {
    if (e instanceof FirebaseError) {
      if (
        e.code === 'auth/expired-action-code' ||
        e.code === 'auth/invalid-action-code'
      ) {
        return false
      }
    }
    throw e
  }
}
